//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";

export default {
  props: {
    article: {},
  },
  data() {
    return {
      Projects: [],
      Departments: [],
      FilterProjects: [],
      FilterDepartments: [],
      DimensionSettings: [],
      FilterDimensionSettings: [],
      SelectedValues: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0 },
      dense: true,
    };
  },

  mounted: function() {
    this.initSelectBox();
  },

  computed: {
    ...mapState("main", ["projects", "departments", "dimensions"]),
  },

  methods: {
    ...mapActions("main", ["getDepartment", "getProject", "getDimensions"]),

    valueChanged(dimension) {
      switch (dimension.dimension) {
        case "1":
          this.article.dimension1Id = this.SelectedValues[dimension.dimension];
          break;
        case "2":
          this.article.dimension2Id = this.SelectedValues[dimension.dimension];
          break;
        case "3":
          this.article.dimension3Id = this.SelectedValues[dimension.dimension];
          break;
        case "4":
          this.article.dimension4Id = this.SelectedValues[dimension.dimension];
          break;
        case "5":
          this.article.dimension5Id = this.SelectedValues[dimension.dimension];
          break;
        case "6":
          this.article.dimension6Id = this.SelectedValues[dimension.dimension];
          break;
        case "7":
          this.article.dimension7Id = this.SelectedValues[dimension.dimension];
          break;
        case "8":
          this.article.dimension8Id = this.SelectedValues[dimension.dimension];
          break;
        case "9":
          this.article.dimension9Id = this.SelectedValues[dimension.dimension];
          break;
        default:
          break;
      }
    },

    async initSelectBox() {
      this.DimensionSettings = this.dimensions;

      if (!this.DimensionSettings) {
        this.DimensionSettings = await this.getDimensions().then(
          (result) => (this.DimensionSettings = result)
        );
      }

      this.DimensionSettings.forEach((dimension) => {
        switch (dimension.dimension) {
          case "1":
            this.SelectedValues[
              dimension.dimension
            ] = this.article.dimension1Id;
            break;
          case "2":
            this.SelectedValues[
              dimension.dimension
            ] = this.article.dimension2Id;
            break;
          case "3":
            this.SelectedValues[
              dimension.dimension
            ] = this.article.dimension3Id;
            break;
          case "4":
            this.SelectedValues[
              dimension.dimension
            ] = this.article.dimension4Id;
            break;
          case "5":
            this.SelectedValues[
              dimension.dimension
            ] = this.article.dimension5Id;
            break;
          case "6":
            this.SelectedValues[
              dimension.dimension
            ] = this.article.dimension6Id;
            break;
          case "7":
            this.SelectedValues[
              dimension.dimension
            ] = this.article.dimension7Id;
            break;
          case "8":
            this.SelectedValues[
              dimension.dimension
            ] = this.article.dimension8Id;
            break;
          case "9":
            this.SelectedValues[
              dimension.dimension
            ] = this.article.dimension9Id;
            break;
          default:
            break;
        }
      });

      // Deep clone : https://www.samanthaming.com/tidbits/70-3-ways-to-clone-objects/#_3-using-json
      this.FilterDimensionSettings = JSON.parse(
        JSON.stringify(this.DimensionSettings)
      );
    },

    getCustomDimensionFilter(val, update, dimension) {
      console.log("getCustomDimensionFilter", this.DimensionSettings);

      if (!this.DimensionSettings) {
        update();
        return;
      }
      update(() => {
        this.FilterDimensionSettings.forEach((value, index) => {
          var valContainsSemicolon = val.indexOf(": ") > 0;
          if (value.dimension === dimension.dimension) {
            var value2 = JSON.parse(JSON.stringify(value));
            console.log(value2);
            this.DimensionSettings[index].dimensions = value2.dimensions.filter(
              (v) =>
                v.name.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
                (valContainsSemicolon &&
                  v.name
                    .toLowerCase()
                    .indexOf(val.split(": ")[1].toLowerCase()) > -1)
            );
          }
        });

        console.log("getCustomDimensionFilter update");
      });
    },
  },
};
